import { isRestrictedEmail } from '@coach-bot/data-access/shared/utils/permissions';
import StudentWorksmartData from '@coach-bot/features/tracking/models/student-worksmart-data';
import { filter, firstValueFrom, take } from 'rxjs';
import { Services } from '../services';

export async function handleTimeTracking(services: Services, email?: string): Promise<void> {
  let worksmartData: StudentWorksmartData | null = null;
  if (!!email && !isRestrictedEmail(email)) {
    const studentId: string | null = await getStudentId(services, email);
    validateEmailAndStudentId(email, studentId);
    try {
      worksmartData = await services.studentService.getStudentWorksmartData();
    } catch (ex) {
      try {
        worksmartData = await services.studentService.getStudentWorksmartDataDeprecated(studentId);
      } catch {}
    }
  }
  toggleTracking(services, worksmartData);
}

async function getStudentId(services: Services, email?: string): Promise<string | null> {
  if (!email) {
    return null;
  }
  try {
    return await firstValueFrom(
      services.commonStore.studentId$.pipe(
        filter(data => !!data),
        take(1)
      )
    );
  } catch (error) {
    console.error('Error fetching student ID:', error);
    return null;
  }
}

function validateEmailAndStudentId(email?: string, studentId?: string | null): void {
  if (!!email !== !!studentId) {
    throw new Error('Email and studentId should be both defined or both undefined');
  }
}

function toggleTracking(services: Services, worksmartData?: StudentWorksmartData): void {
  if (worksmartData) {
    services.timecardTrackingService.startTracking(worksmartData);
  } else {
    services.timecardTrackingService.stopTracking();
  }
}
